import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';

// Light/dark switch for the whole portal (founder ask 2026-08-27). The
// template has shipped a full [data-theme="dark"] stylesheet all along;
// this button was just never mounted. The choice persists per browser in
// localStorage and is applied before first paint by the effect below.
const ThemeToggleButton = () => {
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

    const updateThemeOnHtmlEl = (theme) => {
        document.documentElement.setAttribute('data-theme', theme);
    };

    useEffect(() => {
        updateThemeOnHtmlEl(theme);
    }, [theme]);

    const handleThemeToggle = () => {
        const newTheme = theme === 'dark' ? 'light' : 'dark';
        setTheme(newTheme);
        localStorage.setItem('theme', newTheme);
        updateThemeOnHtmlEl(newTheme);
    };

    return (
        <button
            type="button"
            data-theme-toggle
            title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            className="w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
            onClick={handleThemeToggle}
        >
            <Icon
                icon={theme === 'dark' ? 'ph:sun-bold' : 'ph:moon-bold'}
                className="icon text-xl"
            />
        </button>
    );
};

export default ThemeToggleButton;
